import { Divider, Typography } from '@material-ui/core';
import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';
import * as React from 'react';
import { useStyles } from './styles';

export const UnsupportedBrowser: React.FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <SystemUpdateAltIcon color="primary" />

      <Typography color="inherit" align="center" component="div">
        <Typography variant="h5" gutterBottom>
          Your browser is not supported.
        </Typography>

        <Divider className={classes.divider} />

        <Typography variant="body1" color="textSecondary">
          KonnektTalexio Intranet works best on modern web browsers.
          Unfortunately it appears that your current browser does not support an
          important feature. If you are using an old browser, such as Internet
          Explorer or an out of date version of Chrome, Firefox or Safari, we
          kindly ask you to update to the latest version. If this problem
          persists, please submit a request to our support team using this
          <a
            href="https://support.talexio.com/hc/en-us/requests/new"
            target="_blank"
            rel="noreferrer noopener"
          >
            link
          </a>
        </Typography>
      </Typography>
    </div>
  );
};
